import { render, staticRenderFns } from "./ProcessManage.vue?vue&type=template&id=36defc79&"
import script from "./ProcessManage.vue?vue&type=script&lang=js&"
export * from "./ProcessManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports